import { FormBuilder } from '@angular/forms';
import type { FormGroup } from '@angular/forms';
import { inject, Injectable } from '@angular/core';
import { FIELD_REQUIRED, FormValidator } from '@shared/reactive-forms/form-fields-validate.helper';

@Injectable({
  providedIn: 'root',
})
export class LoginBuildFormService {
  private readonly formBuilder = inject(FormBuilder);

  /**
   * Construye y retorna un formulario de inicio de sesión.
   */
  public buildLoginForm(): FormGroup {
    return this.formBuilder.group({
      email: FormValidator.requiredEmailMinLength(FIELD_REQUIRED),
      password: FormValidator.requiredMinLength(FIELD_REQUIRED, null),
    });
  }
}
